exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".peugeot .order-pagination li a{color:#003755!important}.peugeot .order-pagination li.active a{background-color:#003755;border-color:#003755}.citroen .order-pagination li a{color:#093c7d!important}.citroen .order-pagination li.active a{background-color:#093c7d;border-color:#093c7d}.ds .order-pagination li a{color:#2f2726!important}.ds .order-pagination li.active a{background-color:#2f2726;border-color:#2f2726}.order-pagination{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.order-pagination li.active a{color:#fff!important}.order-pagination li.disabled a{color:#777!important}", ""]);

// exports
